<template>
  <div class="d-flex ml-auto flex-grow-0 align-center" style="height: 30px">
    <v-menu rounded offset-y>
      <template v-slot:activator="{ attrs, on }">
        <v-btn v-bind="attrs" v-on="on" icon>
          <v-icon small color="gray" v-bind="attrs" v-on="on"> mdi-information-outline </v-icon>
        </v-btn>
      </template>
      <div style="background: white;max-height:80vh" class="pa-2 scroll-container">
        <pre><code>{{ JSON.stringify(dutyActivity, null, 2) }}</code></pre>
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'DutyActivityJson',
  props: {
    dutyActivity: Object,
  },
};
</script>
